import * as SignalR from '@aspnet/signalr';
import { getBaseUrl } from './../reducers/domainProperties';

const BASE_URL = getBaseUrl();

let hub = undefined;
let photosUpadateCallabck, 
    dronePositionUpdateCallback,
    liveStreamFinishedCallback,
    liveStreamStartedCallback;

const initWebSocketConnection = (): void => {
    const token = localStorage.getItem('token');
    const tokenWithoutBearer = token ? token.replace('Bearer ', '') : '';
    const hubUrl = `${BASE_URL}drone-hub?token=${tokenWithoutBearer}`;
    hub = new SignalR.HubConnectionBuilder()
        .withUrl(hubUrl)
        .configureLogging(SignalR.LogLevel.Information)
        .build();
    hub.onclose(() => { 
        setTimeout(() => hub.start().catch(err => console.error(err.toString()), 5000));
        if (photosUpadateCallabck) turnOnPhotosUpdateNotification(photosUpadateCallabck);
        if (dronePositionUpdateCallback) turnOnDronePositionUpdateNotification(dronePositionUpdateCallback);
        if (liveStreamFinishedCallback) turnOnLiveStreamFinishedNotification(liveStreamFinishedCallback);
        if (liveStreamStartedCallback) turnOnLiveStreamStartedNotification(liveStreamStartedCallback);
    });
    hub.start().catch(err => console.error(err.toString()));
}

export const turnOnPhotosUpdateNotification = (callback: (message: string) => void): void => {
    photosUpadateCallabck = callback;
    if (!hub) {
        initWebSocketConnection();
    }
    hub.off('PhotosUpdateNotification');
    hub.on('PhotosUpdateNotification', message => {
        // console.log('Backend photos update notification: ' + message);
        callback(message);
    });
}

export const turnOffPhotosUpdateNotification = (): void => {
    hub.off('PhotosUpdateNotification');
}

export const turnOnDronePositionUpdateNotification = (callback: (message: Object) => void): void => {
    dronePositionUpdateCallback = callback;
    if (!hub) {
        initWebSocketConnection();
    }
    hub.off('DronePositionUpdateNotification');
    hub.on('DronePositionUpdateNotification', message => {
        callback(message);
    });
}

export const turnOffDronePositionUpdateNotification = (): void => {
    hub.off('DronePositionUpdateNotification');
}

export const turnOnLiveStreamFinishedNotification = (callback: (message: string) => void): void => {
    liveStreamFinishedCallback = callback;
    if (!hub) {
        initWebSocketConnection();
    }
    hub.off('LiveStreamEndedNotification');
    hub.on('LiveStreamEndedNotification', projectId => {
        callback(projectId);
    });
}

export const turnOffLiveStreamFinishedNotification = (): void => {
    hub.off('LiveStreamEndedNotification');
}

export const turnOnLiveStreamStartedNotification = (callback: (message: string) => void): void => {
    liveStreamStartedCallback = callback;
    if (!hub) {
        initWebSocketConnection();
    }
    hub.off('LiveStreamStartedNotification');
    hub.on('LiveStreamStartedNotification', (projectId, hlsUrl) => {
        callback(projectId, hlsUrl);
    });
}

export const turnOffLiveStreamStartedNotification = (): void => {
    hub.off('LiveStreamStartedNotification');
}


// WEBPACK FOOTER //
// ./src/utilities/webSocketNotifications.js